import { MutationTree } from 'vuex';
import { VForm } from '@/features/common/types';
import { EstimateDataType, EstimateStateType } from '../types';

const mutations: MutationTree<EstimateStateType> = {
  setWhereEstimateForm(state: EstimateStateType, value: VForm) {
    state.estimateTopForm = value;
  },

  setEstimateData(state: EstimateStateType, value: EstimateDataType) {
    state.estimateData = { ...value };
  },

  patchEstimateData(state: EstimateStateType, { key, value }: { key: string, value: never }) {
    state.estimateData[key] = value;

    if (key !== 'signatureOptions') return;

    if (!state.estimateData.packages) return;
    state.estimateData.packages = state.estimateData.packages.map((packageItem) => {
      return {
        ...packageItem,
        signatureOptions: value,
      };
    });
  },
};

export default mutations;
